import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=14906667&scoped=true&"
import script from "./Sold.vue?vue&type=script&lang=js&"
export * from "./Sold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14906667",
  null
  
)

export default component.exports